import Carousel from 'react-bootstrap/Carousel';
import React, { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';


function Homebanner({data}) {

    return (
        <div>
            <Carousel fade className='home-banner' interval={2000}>
                {data !== undefined && data.length > 0 ? data.map((item, index) => {
                    const isOdd = index % 2 !== 0;
                    const alignmentClass = isOdd ? 'home-banner-right' : ' home-banner-left';
                    return (
                        <Carousel.Item className='banner-h' key={item.banner_id} >
                            <img src={item.image}></img>
                            <Carousel.Caption className={`sst ${alignmentClass}`} >
                                <div className="hero-single-slide hero-overlay">
                                    <div className="banner-odd">
                                        <div className="hero-slider-content slide-1">
                                            <h2 className="slide-title">{item.title}<span>Collection</span></h2>
                                            <h4 className="slide-desc"><span dangerouslySetInnerHTML={{ __html: item.description }}></span></h4>
                                            <Link to={item.link} className="btn btn-hero">Read More</Link>
                                        </div>
                                    </div>
                                </div>
                            </Carousel.Caption>
                        </Carousel.Item>
                    )
                }) : null}
            </Carousel>
        </div>
    )
}
export default Homebanner
